import { FiClipboard } from 'react-icons/fi';
import { QuotesViewMain } from '../Components/QuotesViewMain';

export const QuotesModule = () => [{
    views: 'PRIVATE',
    path: '/dashboard/quotes',
    component: <QuotesViewMain />,
    roles: null,
    permissions: null,
    label: 'Cotizaciones',
    icon: <FiClipboard />,
    displayInHeader: false,
    displayInFooter: false,
    displayInSidebar: true,
    isBlockedWhenLogged: false,
}];
